import React, { useEffect, useState } from "react";
import axios from "axios";
import Typist from "react-typist";
import { Player, BigPlayButton, ControlBar } from 'video-react';
import Configs from "../../editable-stuff/configurations.json";
import "../../App";
import { scroller } from 'react-scroll';
import "./CSS/video-react.css";
import sampleVideo from "../Invitations/assets/videos/sample.mp4";

const FALLBACK_VIDEO_URL = sampleVideo;

const scrollFunc = (e) => {
  scroller.scrollTo(e, {
    duration: 1400,
    delay: 0,
    offset: 25,
    smooth: 'easeInOutQuart'
  });
};

const MainHeader = () => {
  const [devInfo] = useState(Configs.devIntro);
  const [devDesc] = useState(Configs.devDesc);
  const [videoUrl, setVideoUrl] = useState(FALLBACK_VIDEO_URL);
  const [posterUrl, setPosterUrl] = useState(null);
  window.document.title = "Personalized e-Invitations";

  useEffect(() => {
    let cancelled = false;
    axios
      .get(process.env.REACT_APP_API_URL + "/GetHomepageVideo")
      .then((response) => {
        if (cancelled) return;
        const data = response.data || {};
        if (data.url) setVideoUrl(data.url);
        if (data.poster) setPosterUrl(data.poster);
      })
      .catch(() => {
        // Keep fallback URL so the homepage never breaks if the API is down.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section id="mainHeader" className="papercraft pc-hero">
      <div className="pc-hero__copy">
        <div className="pc-hero__rule pc-reveal pc-reveal--fast pc-d-1">
          <span className="pc-eyebrow pc-eyebrow--leading">
            Est.&nbsp;NeedForGeeks &nbsp;·&nbsp; New York
          </span>
        </div>

        <h1 className="pc-display pc-hero__title pc-reveal pc-d-2">
          {devInfo}
          <span className="pc-hero__title-mark">.</span>
        </h1>

        <p className="pc-hero__subtitle pc-reveal pc-d-3">
          Save time, save trees, save money. <br />
          <strong>Email invitations</strong> with personalized envelopes
          and built-in <em className="italic">RSVP</em> tracking.
        </p>

        <div className="pc-hero__ticker pc-reveal pc-d-4">
          <Typist avgTypingDelay={30} cursor={{ show: false }}>
            {devDesc}
          </Typist>
        </div>
      </div>

      <div className="pc-hero__media pc-reveal--media pc-reveal pc-d-3">
        <div className="pc-hero__media-inner">
          <Player
            autoPlay
            muted
            playsInline
            fluid={false}
            width="100%"
            height="100%"
            src={videoUrl}
            poster={posterUrl || undefined}
          >
            <BigPlayButton position="center" />
            <ControlBar disableCompletely />
          </Player>
        </div>
        <div className="pc-hero__media-caption">a sample invitation</div>
      </div>

      <button
        type="button"
        className="pc-scrollcue"
        onClick={() => scrollFunc("overview")}
        aria-label="Scroll to overview"
      >
        <span>scroll</span>
        <span className="pc-scrollcue__line" />
      </button>
    </section>
  );
};

export default MainHeader;
